export default "__VITE_ASSET__zFHiKQeK__"